import {useState} from "react";

export const useJsonPopover = () => {
  const [jsonPopover, setJsonPopover] = useState(null);
  const [popoverPos, setPopoverPos] = useState({x: 0, y: 0});

  const showJson = (e, data) => {
    setPopoverPos({x: e.clientX, y: e.clientY});
    setJsonPopover(data);
  };

  const moveJson = (e) => {
    setPopoverPos({x: e.clientX, y: e.clientY});
  };

  const hideJson = () => setJsonPopover(null);

  return {
    jsonPopover,
    popoverPos,
    showJson,
    moveJson,
    hideJson,
  };
};
